<template>
  <div>
    <div v-if="configLoading || stripeInfoLoading" class="text-center pa-6">
      <v-progress-circular
        :size="40"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>

    <v-row v-else>
      <v-col cols="12">
        <div class="title">
          <v-icon class="mr-2">mdi-credit-card</v-icon>
          Stripe
          <v-tooltip top>
            <template v-slot:activator="{on}">
              <v-btn v-on="on" small text color="grey lighten-1" @click="getDataFromApi('latest')"><v-icon>mdi-sync</v-icon></v-btn>
            </template>
            <span>Pull Latest Prices From Stripe</span>
          </v-tooltip>
        </div>
      </v-col>
      <v-col cols="6">
        <div class="overline">Agent Monthly</div>
        <v-select
          v-model="configValues.stripe_agent_price_monthly"
          :items="monthlyPrices"
          hide-details
          outlined
          item-value="id"
          clearable
          @change="updateConfig('stripe_agent_price_monthly', $event)"
          :disabled="configs.stripe_agent_price_monthly.saving"
          :loading="configs.stripe_agent_price_monthly.saving"
        >
          <template v-slot:item="{ item }">
            <v-row>
              <v-col>{{ item.name }}</v-col>
              <v-col class="flex-grow-0 flex-shrink-1 text-no-wrap font-weight-bold primary--text">{{ (item.amount / 100) | currencyRounded }}</v-col>
            </v-row>
          </template>
          <template v-slot:selection="{ item }">
            <v-row>
              <v-col>{{ item.name }}</v-col>
              <v-col class="flex-grow-0 flex-shrink-1 text-no-wrap font-weight-bold primary--text">{{ (item.amount / 100) | currencyRounded }}</v-col>
            </v-row>
          </template>
        </v-select>
      </v-col>
      <v-col cols="6">
        <div class="overline">Partner Monthly</div>
        <v-select
          v-model="configValues.stripe_partner_price_monthly"
          :items="monthlyPrices"
          hide-details
          outlined
          item-value="id"
          clearable
          @change="updateConfig('stripe_partner_price_monthly', $event)"
          :disabled="configs.stripe_partner_price_monthly.saving"
          :loading="configs.stripe_partner_price_monthly.saving"
        >
          <template v-slot:item="{ item }">
            <v-row>
              <v-col>{{ item.name }}</v-col>
              <v-col class="flex-grow-0 flex-shrink-1 text-no-wrap font-weight-bold primary--text">{{ (item.amount / 100) | currencyRounded }}</v-col>
            </v-row>
          </template>
          <template v-slot:selection="{ item }">
            <v-row>
              <v-col>{{ item.name }}</v-col>
              <v-col class="flex-grow-0 flex-shrink-1 text-no-wrap font-weight-bold primary--text">{{ (item.amount / 100) | currencyRounded }}</v-col>
            </v-row>
          </template>
        </v-select>
      </v-col>


      <v-col cols="12">
        <div class="title">
          <v-icon class="mr-2">mdi-account-details</v-icon>
          Active Campaign
        </div>
      </v-col>
      <v-col cols="6">
        <div class="overline">URL</div>
        <v-text-field
          v-model="activeCampaignInfo.active_campaign_url"
          outlined
          hide-details
          @blur="updateConfig('active_campaign_url', activeCampaignInfo.active_campaign_url)"
        />
      </v-col>
      <v-col cols="6">
        <div class="overline">API Key</div>
        <v-text-field
          v-model="activeCampaignInfo.active_campaign_api_key"
          outlined
          hide-details
          @blur="updateConfig('active_campaign_api_key', activeCampaignInfo.active_campaign_api_key)"
        />
      </v-col>
      <v-col cols="3">
        <div class="overline">Registration List</div>
        <v-select
          v-model="activeCampaignInfo.active_campaign_registered_list_id"
          :items="activeCampaignLists"
          hide-details
          outlined
          item-value="id"
          item-text="name"
          clearable
          @change="updateConfig('active_campaign_registered_list_id', $event)"
        />
      </v-col>
      <v-col cols="3">
        <div class="overline">14 Day Free Trial List</div>
        <v-select
          v-model="activeCampaignInfo.active_campaign_free_trial_list_id"
          :items="activeCampaignLists"
          hide-details
          outlined
          item-value="id"
          item-text="name"
          clearable
          @change="updateConfig('active_campaign_free_trial_list_id', $event)"
        />
      </v-col>
      <v-col cols="3">
        <div class="overline">Subscribed List</div>
        <v-select
          v-model="activeCampaignInfo.active_campaign_subscribed_list_id"
          :items="activeCampaignLists"
          hide-details
          outlined
          item-value="id"
          item-text="name"
          clearable
          @change="updateConfig('active_campaign_subscribed_list_id', $event)"
        />
      </v-col>
      <v-col cols="3">
        <div class="overline">Cancelled List</div>
        <v-select
          v-model="activeCampaignInfo.active_campaign_cancelled_list_id"
          :items="activeCampaignLists"
          hide-details
          outlined
          item-value="id"
          item-text="name"
          clearable
          @change="updateConfig('active_campaign_cancelled_list_id', $event)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'AdminSettingsGeneral',
  data: () => ({
    configLoading: true,
    stripeInfoLoading: true,
    activeCampaignLoading: true,

    configs: {},
    configValues: {},
    stripePricing: null,
    activeCampaignInfo: {}
  }),
  mounted () {
    this.getDataFromApi()
  },
  computed: {
    monthlyPrices () {
      if(!this.stripePricing) return []

      let prices = []
      for(let i = 0; i < this.stripePricing.length; i++) {
        if(!this.stripePricing[i].annual) prices.push(this.stripePricing[i])
      }
      return prices
    },
    annualPrices () {
      if(!this.stripePricing) return []

      let prices = []
      for(let i = 0; i < this.stripePricing.length; i++) {
        if(this.stripePricing[i].annual) prices.push(this.stripePricing[i])
      }
      return prices
    },
    activeCampaignLists () {
      if(!this.activeCampaignInfo.active_campaign_lists) return []
      return this.activeCampaignInfo.active_campaign_lists
    }
  },
  methods: {
    getDataFromApi(modifier) {
      this.configLoading      = true
      this.stripeInfoLoading  = true
      this.activeCampaignLoading = true
      let params = ''

      this.$http.get('config' + params)
        .then(response => {
          let result      = {}
          for(let i = 0; i < response.data.length; i++) {
            result[ response.data[i].key ] = response.data[i]
            this.configValues[ response.data[i].key ] = response.data[i].value
          }
          this.configs          = result
          this.configLoading    = false
        })
        .catch(err => {
          if(err.response.status == 401) return;
          if(err.response.status == 405) this.$router.replace({name: 'dashbboard'})
          this.$swal.fire('Error', 'An error has occurred loading the configurations','error')
        })

      
      params = ''
      if(modifier == 'latest') params = '?latest=1'

      this.$http.get('config/stripe-pricing' + params)
        .then(response => {
          this.stripePricing      = response.data
          this.stripeInfoLoading  = false
        })
        .catch(err => {
          if(err.response.status == 401) return
          if(err.response.status == 405) this.$router.replace({name: 'dashbboard'})
          this.$swal.fire('Error', 'An error has occurred loading stripe configuration','error')
        })

      this.$http.get('config/active-campaign')
        .then(response => {
          this.activeCampaignInfo   = response.data
          this.activeCampaignLoading = false
        })
        .catch(err => {
          if(err.response.status == 401) return
          if(err.response.status == 405) this.$router.replace({name: 'dashbboard'})
          this.$swal.fire('Error', 'An error has occurred loading active campaign config','error')
        })
    },
    updateConfig(key, value) {
        if(typeof value === 'undefined') value = null

        if(this.configs[ key ]) this.$set(this.configs[ key ], 'saving', true)
        let params = {
          value: value
        }

        this.$http.put('config/' + key, params)
          .then(() => {
            if(this.configs[ key ]) this.$set(this.configs[ key ], 'saving', false)
          })
          .catch(err => {
            if(err.response.status == 401) return
            this.$swal.fire('Error', 'There was an error updating the config value', 'error')
          })
    }
  }
}
</script>